import * as React from 'react';
import dayjs, { Dayjs } from 'dayjs';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import Stack from '@mui/material/Stack';
import { ThemeProvider, styled } from '@mui/material/styles';
import theme from '../../theme/muiTheme';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CONSTANTS from '../../utils/constants/UIConstants';
interface DatePickerExpandedProps {
	label: string;
	value: Dayjs | null;
	onChange: (value: unknown, keyboardInputValue?: string) => void;
	addStyle?: string;
	disabled?: boolean;
	height?: number
}

const StyledPicker = styled(MobileDateTimePicker)({
	'& .MuiPickersModalDialogActions-buttonAction.MuiPickersModalDialogActions-ok':
		{
			backgroundColor: theme.palette.primary.main,
			'&:hover': {
				backgroundColor: theme.palette.primary.dark,
			},
		},
});

const DatePickerExpanded: React.FC<DatePickerExpandedProps> = (props) => {
	return (
		<ThemeProvider theme={theme}>
			<LocalizationProvider dateAdapter={AdapterDayjs}>
				<Stack spacing={1}>
					<StyledPicker
						value={props.value}
						onChange={props.onChange}
						label={props.label}
						onError={console.log}
						maxDate={dayjs()}
						inputFormat="YYYY/MM/DD hh:mm A"
						mask="____/__/__ __:__ _M"
						disabled={props.disabled}
						renderInput={(params) => (
							<TextField
								{...params}
								className={props.addStyle}
								label={props.label}
								style={{
									width: '338px',
									height: `${props.height ?? 48}px`,
									fontFamily: 'Jost, sans-serif !important',
								}}
								sx={{
									'& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
										borderRadius: '2px',
									},
									'& .MuiInputLabel-root.MuiInputLabel-shrink':  {
                                        maxWidth: props.label.length >= 10 ? '130%' : '100%',
                                        backgroundColor: CONSTANTS.TEXT_INPUT_LABEL_BACKGROUND,
                                        padding: '0.25rem 0.35rem 0 0.35rem',
                                        marginLeft: '-0.35rem',
                                        marginTop: '-0.10rem',
                                        borderRadius: '5px',
                                    },

									...(!props.disabled
										? {}
										: {
												'.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline':
													{
														border: 'none',
													},
												'.Mui-disabled': {
													color: '#556670',
												},
												'.MuiFormLabel-root.Mui-disabled':
													{
														color: '#556670',
													},
												'& .MuiInputBase-input.Mui-disabled':
													{
														WebkitTextFillColor:
															'#2C2C2C',
													},
										  }),
								}}
								InputProps={{
									...params?.InputProps,
									endAdornment: (
										<React.Fragment>
											{params?.InputProps?.endAdornment}
											{!props.disabled && (
												<CalendarTodayIcon
													style={{
														color: theme.palette
															.text.secondary,
													}}
												/>
											)}
										</React.Fragment>
									),
								}}
							/>
						)}
						ToolbarComponent={() => null}
						componentsProps={{
							actionBar: { actions: ['accept', 'cancel'] },
						}}
					/>
				</Stack>
			</LocalizationProvider>
		</ThemeProvider>
	);
};

export default DatePickerExpanded;
